<template>
  <div class="status-text">
    <span style="color: #409EFF;" v-if="status == 0">
      <el-tooltip class="item" effect="dark" content="Pending 準備中" placement="top">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-pending"></use>
        </svg>
      </el-tooltip>
    </span>
    <span style="color:#c810d4;" v-if="status == 1">
      <el-tooltip class="item" effect="dark" content="Approved 已審核" placement="top">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-approved"></use>
        </svg>
      </el-tooltip>
    </span>
    <span style="color:#d8d108;" v-if="status == 2">
      <el-tooltip class="item" effect="dark" content="Processing 處理中" placement="top">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-processing"></use>
        </svg>
      </el-tooltip>
    </span>
    <span style="color: #179A16;" v-if="status == 3">
      <el-tooltip class="item" effect="dark" content="Success 已完成 " placement="top">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-success"></use>
        </svg>
      </el-tooltip>
    </span>
    <span style="color: #e95801;" v-if="status == 4">
      <el-tooltip class="item" effect="dark" content="Fail 失敗" placement="top">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-fail"></use>
        </svg>
      </el-tooltip>
    </span>
    <span style="color: #ccc;" v-if="status == 5">
      <el-tooltip class="item" effect="dark" content="Deleted 已刪除" placement="top">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-delete"></use>
        </svg>
      </el-tooltip>
    </span>
  </div>
</template>
<script>
export default {
  name: 'statusText',
  props: ['status'],
}
</script>

<style scoped>
.status-text{
  font-size:20px;
  font-weight:700;
}
</style>